import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/services/user.service';
import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { delay, take } from 'rxjs/operators';

@Component({
  selector: 'townip-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private userService: UserService,
              private router: Router,
              private authService: AuthService) { }

  public ngOnInit(): void {
    // A logout route is needed for other canDeactivate guards to work properly
    this.userService.logout();

    this.authService
      .connectedEmitter
      .pipe(
        take(1),
        delay(1000) // Delay for a "smoother" transition
      )
      .subscribe(() => {
        this.router.navigate(['/auth/login']);
      });
  }
}
